import React from 'react';
import { FC } from 'react';

import { DateTime } from 'luxon';

import { Badge } from '@shared/components/bootstrap';

import { client } from '@admin/libraries/apollo';
import { Order, Pricing__PerItemCredit, useAccountPerItemCreditsSummaryQuery } from '@admin/schema';

const AccountPerItemPricingCredit: FC<{
  credit: Pick<Pricing__PerItemCredit, 'id' | 'freeItemCount' | 'receivedOn' | 'expiresOn'> & {
    order?: Pick<Order, 'id'> | null;
  };
}> = ({ credit }) => {
  const now = DateTime.now();
  const received = DateTime.fromISO(credit.receivedOn);
  const expires = DateTime.fromISO(credit.expiresOn);

  const status = (() => {
    if (now.startOf('day') < received.startOf('day')) return 'Pending';
    if (now.endOf('day') > expires.endOf('day')) return 'Expired';

    return credit.order ? 'Redeemed' : 'Available';
  })();

  return (
    <>
      <strong>{credit.freeItemCount} free 1-mover items</strong> for a pickup / return redeemable between{' '}
      <strong>{received.toLocaleString(DateTime.DATE_MED)}</strong>
      <span> and </span>
      <strong>{expires.toLocaleString(DateTime.DATE_MED)}</strong>
      <> </>
      <Badge style="info">{status}</Badge>
    </>
  );
};

export const AccountPerItemCreditsSummary: FC<{
  accountID: number;
}> = ({ accountID }) => {
  const { data } = useAccountPerItemCreditsSummaryQuery({
    variables: { accountID: String(accountID) },
    client,
  });

  const credits = data?.account?.pricingPerItemCredits;

  if (!credits) return null;
  if (credits.length === 0) return null;

  return (
    <div>
      <strong>Appointment Discounts/Coupons:</strong>
      <ul>
        {credits.map((credit) => (
          <li key={credit.id}>
            <AccountPerItemPricingCredit key={credit.id} credit={credit} />
          </li>
        ))}
      </ul>
    </div>
  );
};
